module.exports = __webpack_public_path__ + "img/Frame 719.3fa4b98e.png";